(() => {
  const headings = new Set();
  const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
  let frame = 0;
  let hasScrolled = false;

  function enabled() {
    return !reducedMotion.matches && document.body.dataset.lrsMotion !== 'false';
  }

  function channels(value, fallback) {
    const hex = value.trim().replace(/^#/, '');
    if (/^[0-9a-f]{6}$/i.test(hex)) {
      return [0, 2, 4].map(start => parseInt(hex.slice(start, start + 2), 16));
    }
    if (/^[0-9a-f]{3}$/i.test(hex)) {
      return [...hex].map(channel => parseInt(channel + channel, 16));
    }
    return fallback;
  }

  function reset() {
    headings.forEach(heading => heading.style.removeProperty('--scroll-heading-color'));
  }

  function paint() {
    frame = 0;
    if (!enabled()) { reset(); return; }
    const root = getComputedStyle(document.documentElement);
    const ink = channels(root.getPropertyValue('--ink'), [34, 34, 34]);
    const blue = channels(root.getPropertyValue('--lrs-blue'), [17, 30, 38]);
    const viewport = window.innerHeight;
    const start = viewport * 0.8;
    const distance = viewport * 0.52;
    headings.forEach(heading => {
      if (!heading.isConnected) { headings.delete(heading); return; }
      const progress = Math.min(1, Math.max(0, (start - heading.getBoundingClientRect().top) / distance));
      const amount = progress * 0.45;
      const color = `rgb(${ink.map((channel, index) => Math.round(channel + (blue[index] - channel) * amount)).join(', ')})`;
      if (heading.style.getPropertyValue('--scroll-heading-color') !== color) {
        heading.style.setProperty('--scroll-heading-color', color);
      }
    });
  }

  function schedule() {
    if (!frame) frame = requestAnimationFrame(paint);
  }

  function collect(scope) {
    if (scope.matches?.('[data-scroll-tint]')) headings.add(scope);
    scope.querySelectorAll('[data-scroll-tint]').forEach(heading => headings.add(heading));
  }

  collect(document);
  window.addEventListener('scroll', () => {
    hasScrolled = true;
    if (headings.size) schedule();
  }, { passive: true });
  window.addEventListener('resize', () => { if (hasScrolled && headings.size) schedule(); });
  reducedMotion.addEventListener('change', () => {
    if (enabled() && hasScrolled) schedule();
    else reset();
  });
  document.addEventListener('shopify:section:load', event => collect(event.target));
  document.addEventListener('shopify:section:unload', event => {
    headings.forEach(heading => {
      if (event.target === heading || event.target.contains(heading)) {
        heading.style.removeProperty('--scroll-heading-color');
        headings.delete(heading);
      }
    });
  });
})();
